<template>
  <div
    class="m-tab-group__content"
    v-show="isActive"
    :aria-expanded="isActive ? 'true' : 'false'"
    :aria-hidden="!isActive ? 'true' : 'false'"
    :id="id"
  >
    <slot></slot>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      id: "tab_" + uuidv4(),
    }
  },
  inject: ["register", "unregister", 'tabChange'],
  created() {
    if (this.register) {
      this.register(this)
    }
  },
  mounted() {
    this.isActive = this.active
  },
  unmounted() {
    if (this.unregister) {
      this.unregister(this)
    }
  },
  methods: {
    hide() {
      this.isActive = false
    },
    setActive() {
      this.isActive = true

      if (this.tabChange) {
        this.tabChange(this, this.isActive)
      }
    },
  },
}
</script>
